import React from 'react';
const RealtimeIcon = () => {
  return React.createElement("svg", {
    width: '40',
    height: '40',
    viewBox: '0 0 40 40',
    fill: 'none',
    xmlns: 'http://www.w3.org/2000/svg'
  }, React.createElement("rect", {
    width: '40',
    height: '40',
    rx: '20',
    fill: 'url(#paint0_linear_5_2135)'
  }), React.createElement("rect", {
    width: '40',
    height: '40',
    rx: '20',
    fill: 'url(#paint1_radial_5_2135)',
    fillOpacity: '0.6'
  }), React.createElement("path", {
    d: 'M13 22.2891C12.776 22.2891 12.5859 22.2109 12.4297 22.0547C12.2786 21.8984 12.2031 21.7083 12.2031 21.4844V18.2344C12.2031 18.0104 12.2786 17.8203 12.4297 17.6641C12.5859 17.5026 12.776 17.4219 13 17.4219C13.224 17.4219 13.4141 17.5026 13.5703 17.6641C13.7318 17.8203 13.8125 18.0104 13.8125 18.2344V21.4844C13.8125 21.7083 13.7318 21.8984 13.5703 22.0547C13.4141 22.2109 13.224 22.2891 13 22.2891ZM15.7969 25.6328C15.5729 25.6328 15.3828 25.5547 15.2266 25.3984C15.0755 25.2422 15 25.0521 15 24.8281V14.8906C15 14.6615 15.0755 14.4688 15.2266 14.3125C15.3828 14.1562 15.5729 14.0781 15.7969 14.0781C16.026 14.0781 16.2188 14.1562 16.375 14.3125C16.5312 14.4688 16.6094 14.6615 16.6094 14.8906V24.8281C16.6094 25.0521 16.5312 25.2422 16.375 25.3984C16.2188 25.5547 16.026 25.6328 15.7969 25.6328ZM18.5938 28.4766C18.3698 28.4766 18.1797 28.3984 18.0234 28.2422C17.8724 28.0859 17.7969 27.8958 17.7969 27.6719V12.0469C17.7969 11.8229 17.8724 11.6328 18.0234 11.4766C18.1797 11.3203 18.3698 11.2422 18.5938 11.2422C18.8229 11.2422 19.0156 11.3203 19.1719 11.4766C19.3281 11.6328 19.4062 11.8229 19.4062 12.0469V27.6719C19.4062 27.8958 19.3281 28.0859 19.1719 28.2422C19.0156 28.3984 18.8229 28.4766 18.5938 28.4766ZM21.3906 24.5156C21.1667 24.5156 20.9766 24.4375 20.8203 24.2812C20.6693 24.125 20.5938 23.9349 20.5938 23.7109V16.0078C20.5938 15.7839 20.6693 15.5938 20.8203 15.4375C20.9766 15.276 21.1667 15.1953 21.3906 15.1953C21.6146 15.1953 21.8047 15.276 21.9609 15.4375C22.1224 15.5938 22.2031 15.7839 22.2031 16.0078V23.7109C22.2031 23.9349 22.1224 24.125 21.9609 24.2812C21.8047 24.4375 21.6146 24.5156 21.3906 24.5156ZM24.1953 26.7734C23.9661 26.7734 23.7734 26.6953 23.6172 26.5391C23.4661 26.3828 23.3906 26.1927 23.3906 25.9688V13.75C23.3906 13.526 23.4661 13.3359 23.6172 13.1797C23.7734 13.0234 23.9661 12.9453 24.1953 12.9453C24.4193 12.9453 24.6094 13.0234 24.7656 13.1797C24.9219 13.3359 25 13.526 25 13.75V25.9688C25 26.1927 24.9219 26.3828 24.7656 26.5391C24.6094 26.6953 24.4193 26.7734 24.1953 26.7734ZM26.9844 23.0703C26.7604 23.0703 26.5703 22.9922 26.4141 22.8359C26.263 22.6797 26.1875 22.4922 26.1875 22.2734V17.4453C26.1875 17.2266 26.263 17.0391 26.4141 16.8828C26.5703 16.7214 26.7604 16.6406 26.9844 16.6406C27.2135 16.6406 27.4062 16.7214 27.5625 16.8828C27.7188 17.0391 27.7969 17.2266 27.7969 17.4453V22.2734C27.7969 22.4922 27.7188 22.6797 27.5625 22.8359C27.4062 22.9922 27.2135 23.0703 26.9844 23.0703Z',
    fill: 'white'
  }), React.createElement("defs", null, React.createElement("linearGradient", {
    id: 'paint0_linear_5_2135',
    x1: '2.31884',
    y1: '16.4286',
    x2: '22.6346',
    y2: '44.4233',
    gradientUnits: 'userSpaceOnUse'
  }, React.createElement("stop", {
    stopColor: '#7701BB'
  }), React.createElement("stop", {
    offset: '0.0745527',
    stopColor: '#7601BB'
  }), React.createElement("stop", {
    offset: '0.146751',
    stopColor: '#7503BC'
  }), React.createElement("stop", {
    offset: '0.216879',
    stopColor: '#7205BD'
  }), React.createElement("stop", {
    offset: '0.285219',
    stopColor: '#6E09BF'
  }), React.createElement("stop", {
    offset: '0.352055',
    stopColor: '#690DC1'
  }), React.createElement("stop", {
    offset: '0.41767',
    stopColor: '#6312C4'
  }), React.createElement("stop", {
    offset: '0.482348',
    stopColor: '#5C18C7'
  }), React.createElement("stop", {
    offset: '0.54637',
    stopColor: '#541FCA'
  }), React.createElement("stop", {
    offset: '0.610022',
    stopColor: '#4C27CE'
  }), React.createElement("stop", {
    offset: '0.673586',
    stopColor: '#422FD2'
  }), React.createElement("stop", {
    offset: '0.737345',
    stopColor: '#3738D7'
  }), React.createElement("stop", {
    offset: '0.801582',
    stopColor: '#2C42DC'
  }), React.createElement("stop", {
    offset: '0.866582',
    stopColor: '#204DE1'
  }), React.createElement("stop", {
    offset: '0.932627',
    stopColor: '#1358E7'
  }), React.createElement("stop", {
    offset: '1',
    stopColor: '#0564ED'
  })), React.createElement("radialGradient", {
    id: 'paint1_radial_5_2135',
    cx: '0',
    cy: '0',
    r: '1',
    gradientUnits: 'userSpaceOnUse',
    gradientTransform: 'translate(-1.33333 3.64486) rotate(54.1134) scale(20.1871 30.2641)'
  }, React.createElement("stop", {
    stopColor: '#F5EBFA'
  }), React.createElement("stop", {
    offset: '0.161458',
    stopColor: '#EEDEF6',
    stopOpacity: '0.864583'
  }), React.createElement("stop", {
    offset: '0.333333',
    stopColor: '#E8D2F3',
    stopOpacity: '0.735701'
  }), React.createElement("stop", {
    offset: '0.661458',
    stopColor: '#D1A8E8',
    stopOpacity: '0.290563'
  }), React.createElement("stop", {
    offset: '0.822917',
    stopColor: '#C999E4',
    stopOpacity: '0.137944'
  }), React.createElement("stop", {
    offset: '1',
    stopColor: '#C28CE0',
    stopOpacity: '0'
  }))));
};
export default RealtimeIcon;